import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FaviconSwitchComponent } from 'src/app/shared/components/base-reset-password/favicon-switch.component';

@Component({
  selector: 'app-sas-station-register-send',
  templateUrl: './sas-station-register-send.component.html',
  styleUrls: [
    './sas-station-register-send.component.css',
    '../style/global.css',
  ],
})
export class SasStationRegisterSendComponent
  extends FaviconSwitchComponent
  implements OnInit {
  initialized = false;
  constructor(title: Title) {
    super();
    title.setTitle('認証用URL送信完了 | オンラインSASステーション™');
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.initialized = true;
    }, 1000);
  }
}
